import { render, staticRenderFns } from "./gTable.vue?vue&type=template&id=6632f45b&scoped=true&"
import script from "./gTable.vue?vue&type=script&lang=js&"
export * from "./gTable.vue?vue&type=script&lang=js&"
import style0 from "./gTable.vue?vue&type=style&index=0&id=6632f45b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632f45b",
  null
  
)

export default component.exports